/**
 * Created by lzy 19-11-03
 * 百家号新建稿件
 */
'use strict';
angular.module('editBaijiahaoToBeCompiledNewsModule', []).controller('editingCenterBaijiahaoNewsCtrl', [
    '$scope',
    'beforeonload',
    '$element',
    '$compile',
    '$q',
    '$state',
    '$validation',
    '$timeout',
    'trsHttpService',
    'modalDialog',
    'jsonArrayToStringService',
    'editingCenterService',
    'storageListenerService',
    'ueditorService',
    'editIsLock',
    'iWoService',
    'globleParamsSet',
    'baijiahaoService',
    'editPictureService',
    'editingMediatype',
    'newMediaService',
    'baijiaConst',
    'messagePublishService',
    'sensitiveWordCheckService',
    function (
        $scope,
        beforeonload,
        $element,
        $compile,
        $q,
        $state,
        $validation,
        $timeout,
        trsHttpService,
        modalDialog,
        jsonArrayToStringService,
        editingCenterService,
        storageListenerService,
        ueditorService,
        editIsLock,
        iWoService,
        globleParamsSet,
        baijiahaoService,
        editPictureService,
        editingMediatype,
        newMediaService,
        baijiaConst,
        messagePublishService,
        sensitiveWordCheckService
    ) {
        initStatus();
        initData();
        baijiahaoService.addFuture($scope, ['sendmessage']);
        
        /**
         * [initStatus description]初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.status = {
                showByNum: '',
                support: {
                    content: ''
                },
                baijiahaoFormError: [],
                switch: 'manuscriptInfo',
                isOriginal: $state.params.isOriginal,
                progressss: 0,
                topAttachFilePicSize: '3,2',
                isFusionEditor: $state.current.name === 'fusionnews', // 是否来自融合编辑器
                isEditDraft: !!$state.params.baijiahaoarticleid,
                baijiahaoarticleid: $state.params.baijiahaoarticleid,
                isawaitrevise: !!$state.params.isawaitrevise, // 是否待修订
                mediaType: editingMediatype.baijiahao
            };
            $scope.data = {
                listStyle: [
                    {
                        name: '单图',
                        value: '1'
                    },
                    {
                        name: '二图',
                        value: '2'
                    },
                    {
                        name: '三图',
                        value: '3'
                    }
                ],
                scaleImgSize: globleParamsSet.scaleImgSize(),
                version: [], // 流程展示数据
                copyVersion: [],
                trench: baijiaConst.listenStroageKey
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.editFlag = {
                media: 'baijiahao', 
                docType: 'news',
            };
        }

        /** **************************适应融合编辑器切换渠道开始**************************/
        /**
         * [initData description]初始化数据
         * @param   {[type]}  dealWithListFun  [dealWithListFun description] 传入方法
         * @return  {[type]}                   [return description]
         */
        $scope.initData = function (dealWithListFun) {
            var defer = $q.defer();
            if ($state.params.baijiahaoarticleid) {
                initEditData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            } else {
                initNewData(dealWithListFun).then(function () {
                    defer.resolve();
                });
            }
            return defer.promise;
        };

        /** **************************适应融合编辑器切换渠道结束**************************/
        /**
     * [initData description]初始化数据
     * @return {[type]} [description]
     */
        function initData() {
            if (!$scope.status.isFusionEditor) {
                initArrayBtn();
                ($state.params.baijiahaoarticleid ? initEditData() : initNewData()).then(function () {
                    beforeonload.beforeonloadAlert($scope);
                });
            }
            $scope.handleBtnClick = function (funname) {
                eval('$scope.' + funname + '()');
            };
            emitCloseWindow();
        }

        /**
         * [initNewData description]初始化新稿件
         * @param   {[type]}  dealWithListFun  [dealWithListFun description] 传入方法
         * @return  {[type]}                   [return description]
         */
        function initNewData(dealWithListFun) {
            var defer = $q.defer();
            $scope.list = {
                serviceid: 'mlf_baijiahao',
                methodName: 'save',
                DOCTYPEID: 1,
                BAIJIAHAOARTICLEID: $state.params.baijiahaoarticleid || 0,
                // BAIJIAHAOACCOUNTID: $state.params.baijiahaoaccount,
                ACCOUNTID: $state.params.baijiahaoaccount,
                TITLE: '',
                CONTENT: '',
                HTMLCONTENT: '',
                FGD_EDITINFO: [],
                FGD_AUTHINFO: [{ isCreate: true }],
                POSTER: [{}],
                ORIGINAL: 0,
                SPECIALDOC: 0,
                ISNOPAYMENT: '1'
            };
            $scope.status.showByNum = '1';
            initDocgenre();
            // 融合编辑器下处理list
            if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                dealWithListFun();
            }
            loadDirective().then(function () {
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [initEditData description]查询以保存的稿件
         * @param   {[type]}  dealWithListFun  [dealWithListFun description]传入方法
         * @return  {[type]}                   [return description]
         */
        function initEditData(dealWithListFun) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_baijiahao',
                methodName: 'getBaiJiaHaoArticle',
                baiJiaHaoArticleId: $state.params.baijiahaoarticleid
            };
            // 适应融合编辑
            if ($scope.status.isFusionEditor) {
                params = {
                    serviceid: 'mlf_fusionbaijia',
                    methodname: 'getBaiJiaVirtualDoc',
                    SourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid
                };
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                $scope.list = data;
                $scope.data.remarks = data.REMARKS;
                document.title = data.TITLE;
                $scope.list.serviceid = 'mlf_baijiahao';
                $scope.list.methodName = 'save';
                if (!$scope.list.POSTER) {
                    $scope.list.POSTER = [];
                    // $scope.list.POSTERURL = [];
                }
                $scope.status.showByNum = $scope.list.POSTER.length === 0 ? '1' : $scope.list.POSTER.length;
                if ($scope.list.POSTER.length < 3) {
                    // showAddCover();
                }
                loadDirective().then(function () {
                    defer.resolve();
                });
                initDocgenre($scope.list);
                showVersion();
                // 融合编辑下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
            });
            //  稿件加锁
            editIsLock.lockDraft($state.params.baijiahaoarticleid);
            return defer.promise;
        }

        /**
         * [initDocgenre description]初始化稿件体裁
         * @param   {[type]}  obj  [obj description]list对象
         * @return  {[type]}       [return description]
         */
        function initDocgenre(obj) {
            iWoService.initData().then(function (data) {
                $scope.data.docgenre = data.DocGenre;
                $scope.list.DOCGENRE = obj ? obj.DOCGENRE : angular.copy($scope.data.docgenre[0]);
            });
        }

        /**
         * [getPropagandaReview description]获取宣传部评审流程
         * @return  {[type]}  [return description]
         */
        function getPropagandaReview() {
            var deffer = $q.defer();
            editingCenterService.getPropagandaReview($scope.status.mediaType, $state.params.baijiahaoarticleid).then(function (data) {
                $scope.data.propagandaReview = data;
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [picCallbackData description] 点击获取封面图的回调
         * @return {[type]} [description]
         */
        $scope.picCallbackData = function () {
            var picresize;
            var freeIndex = fullList();
            if (freeIndex === -1) {
                modalDialog.alertType('封面图已填充满', '', 'warning', false);
                return;
            }
            picresize = $scope.status.topAttachFilePicSize;
            return function (fileName) {
                editPictureService.newCropperApp(fileName, picresize).then(
                    function (src) {
                        $scope.list.POSTER.push({
                            IMAGENAME: src.imgName || src.APPFILE,
                            IMAGEDESC: src.imgName || src.APPDESC,
                            IMAGEURL: src.imgSrc || src.PERPICURL,
                        });
                    },
                    function () { }
                );
            };
        };

        /**
         * [fullList description] 判断封面图列表是否充满
         * @return  {[type]}  [return description]
         */
        function fullList() {
            var coverList = $scope.list.POSTER;
            for (var i = 0; i < coverList.length; i++) {
                if (coverList[i] && !coverList[i].IMAGENAME) {
                    coverList.splice(i, 1);
                }
            }
            if (!coverList.length) {
                return 0;
            }
            if (coverList.length < $scope.status.showByNum) {
                return 0;
            }
            return -1;
        }

        /**
         * [loadDirective description]动态加载指令
         * @return  {[type]}  [return description]
         */
        function loadDirective() {
            var defer = $q.defer();
            editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
            if ($state.params.issave === undefined || $state.params.issave === '0') {
                LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                    var ueditor =
                        '<ueditor class="newEditor" edit-flag="editFlag" versionid="data.lastVersionid" type="{{\'newmedia\'}}" show-cover-btn="{{\'true\'}}" callback="picCallbackData()" infullscreen="status.infullscreen" list="list" has-content="status.hasContent"></ueditor>';
                    ueditor = $compile(ueditor)($scope);
                    $element.find('ueditorLocation').append(ueditor);
                    var ue = UE.getEditor('ueditor');
                    $scope.status.support.content = $scope.list.CONTENT;
                    ue.ready(function () {
                        ue.addListener('keydown', function (type, event) {
                            if (event.keyCode === 13) {
                                $scope.status.support.content = ue.getContentTxt();
                            }
                        });
                        defer.resolve();
                    });
                    var supportCreation =
                        '<support-creation is-trs-check-menu="{{\'true\'}}" parent-status="status" big-face-switch="status.bigFaceSwitch" has-editor="true" is-news="true" media-type="{{\'2\'}}" is-check-sensitive-words="status.isCheckSensitiveWords" list="list"></support-creation>';
                    supportCreation = $compile(supportCreation)($scope);
                    $element.find('supportcreation').append(supportCreation);
                    if (!$scope.status.isFusionEditor) {
                        // 非融合编辑下的加载发稿单
                        var draftList =
                            '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="bjhNewsForm"></editor-dir>' +
                            '<editor-auth-dir author="list.FGD_AUTHINFO"></editor-auth-dir>';
                        draftList = $compile(draftList)($scope);
                        $element.find('editor').append(draftList);
                    }
                });
            } else {
                defer.resolve();
            }
            return defer.promise;
        }

        /**
         * [loadFgd description]加载发稿单（融合编辑下的加载发稿单）
         * @return  {[type]}  [return description]
         */
        $scope.loadFgd = function () {
            var draftList =
                '<editor-dir  list="list" meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="bjhNewsForm"></editor-dir>' +
                '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
            draftList = $compile(draftList)($scope);
            $element.find('editor').append(draftList);
        };

        /* 稿件操作开始*/
        /**
         * [save description] 保存稿件
         * @param {[type]} [flag] [description] 是否为操作前的保存
         * @return {[type]} [description]
         */
        $scope.save = function () {
            var defer = $q.defer();
            saveList(true).then(
                function () {
                    // 保存成功后的处理
                    storageListenerService.addListenerToBaijiahao('save');
                    $scope.status.isEditDraft = true;
                    if (($scope.$root.cureditpage || $scope.$root.cureditpage === 'baijiahaonews') && $scope.status.isFusionEditor) {
                        // 重新请求页面内容（融合编辑）
                        var params = {
                            serviceid: 'mlf_fusionbaijia',
                            methodname: 'getBaiJiaVirtualDoc',
                            SourceDocId: $scope.data.sourceDocId || $state.params.iwometadataid
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(
                            function (data) {
                                var ue = UE.getEditor('ueditor');
                                ue.ready(function () {
                                    ue.setContent(
                                        data.HTMLCONTENT.replace(/<trs_page_separator pagetitle="" firstpagetitle=""><\/trs_page_separator>/g, '<hr ispageseparator="true"/>')
                                    );
                                    $scope.data.initContent = ue.getContent();
                                    ueditorService.saveToLocal($scope.list.BAIJIAHAOARTICLEID, 'baijiahao', data.HTMLCONTENT, $scope.data.lastVersionid);
                                    defer.resolve();
                                });
                            },
                            function () {
                                defer.resolve();
                            }
                        );
                    }
                    $state.transitionTo($state.current, $state.params, {
                        reload: false
                    });
                    // 保存
                    showVersion();
                    if (!$scope.status.isFusionEditor) {
                        $timeout(function () {
                            modalDialog.saveModel('保存成功', '', 'success');
                        }, 500);
                    }
                    defer.resolve();
                },
                function (msg) {
                    modalDialog.alertType('保存失败', '', 'warning', false);
                    defer.reject(msg);
                }
            );
            return defer.promise;
        };

        /**
         * [saveList description]切换时保存list数据
         *
         * @param   {[type]}  flag  [flag description] 判断是否进行加锁操作，如果关闭页面则不加锁，不关闭则加锁
         *
         * @return  {[type]}        [return description]
         */
        function saveList(flag) {
            var defer = $q.defer();
            // 处理发稿单作者信息空数据提交问题
            if ($scope.status.isFusionEditor) {
                $scope.list.serviceid = 'mlf_fusionbaijia';
                $scope.list.methodName = 'saveBaiJiaVirtualDoc';
                $scope.list.SourceDocId = $scope.data.sourceDocId || $state.params.baijiahaoarticleid;
                $scope.list.FusionBaiJiaId = $state.params.baijiahaoarticleid || '0';
            } else {
                ueditorService.saveContent($scope.list);
            }
            // $validation.validate($scope.bjhNewsForm.authorForm);
            $scope.bjhNewsForm.$pending = {};
            $validation
                .validate($scope.bjhNewsForm)
                .success(function () {
                    modalDialog.isSecretInformation(
                        true,
                        function () {
                            sensitiveWordCheckService.sensitiveWords($scope).then(function (sensitiveWords) {
                                var list = angular.copy($scope.list);
                                list.ORIGINALTYPE = $scope.data.originType;
                                list.SPECIALDOC = $scope.data.specialDoc;
                                list.BAIJIAHAOARTICLEID = $state.params.baijiahaoarticleid || '0';
                                for (var i = 0; i < list.POSTER.length; i++) {
                                    if (!list.POSTER[i].IMAGENAME) {
                                        list.POSTER.splice(i, 1);
                                    }
                                }
                                if (list.POSTER.length === 0) {
                                    modalDialog.alertType('保存失败', '百家号新闻稿请上传1-3张封面图', 'warning', false);
                                    return;
                                }
                                // 传了三张图 但是如果最后是保存的时候选择的图片数比上传的少 应该把多上传的图片给干掉
                                list.POSTER = list.POSTER.slice(0, $scope.status.showByNum);
                                list = jsonArrayToStringService.jsonArrayToString(list);
                                $scope.bjhNewsForm.$setPristine();
                                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(function (data) {
                                    $state.params.baijiahaoarticleid = $scope.list.baijiahaoarticleid = data.METADATAID.replace(/\"/g, ''); // 后台返回的是字符串，需要转成数字类型
                                    beforeonload.refresh($scope);
                                    //  稿件加锁
                                    if (flag) {
                                        editIsLock.lockDraft($state.params.baijiahaoarticleid);
                                    }
                                    defer.resolve(data);
                                });
                            });
                        },
                        function () {
                            defer.reject();
                        }
                    );
                })
                .error(function () {
                    editingCenterService.checkSaveError($scope.bjhNewsForm, $element, $scope);
                    defer.reject({
                        plat: '百家号'
                    });
                });
            return defer.promise;
        }

        /**
         * [initArrayBtn description]初始化按钮
         * @return {[type]} [description]
         */
        function initArrayBtn() {
            baijiahaoService.initEditerBtn($state.params.baijiahaoplatform, $state.params.baijiahaoaccount).then(function(data) {
                $scope.arrayBtn = data;
            });
        }

        /**
         * [baijiahaoTrial description]送审操作
         * @return {[type]} [description]
         */
        $scope.baijiahaoTrial = function () {
            newMediaService.trial($scope, baijiaConst.trial).then((opinion) => {
                saveList().then(function () {
                    let baijiaParams = angular.extend({
                        baiJiaHaoArticleIds: $state.params.baijiahaoarticleid, accountId: $state.params.baijiahaoaccount,
                        opinion: opinion
                    }, baijiaConst.trial);
                    messagePublishService.publish('doEditPageOperation', baijiaParams);
                });
            });
        };

        /**
         * [baijiahaoKill description]撤稿操作
         * @return  {[type]}  [return description]
         */
        $scope.baijiahaoKill = function () {
            newMediaService.rejection($scope, baijiaConst.drawNews).then((opinion) => {
                saveList().then(function () {
                    let baijiaParams = angular.extend(
                        {
                            baiJiaHaoArticleIds: $state.params.baijiahaoarticleid,
                            accountId: $state.params.account,
                            opinion: opinion
                        },
                        baijiaConst.drawNews
                    );
                    messagePublishService.publish('doEditPageOperation', baijiaParams);
                });
            });
        };


        /**
         * [baijiahaoSign description]签发操作
         * @return {[type]} [description]
         */
        $scope.baijiahaoSign = function () {
            $scope.loadingPromise = newMediaService.sign($scope, baijiaConst.sign, function(params, selectedArray) {
                params.baiJiaHaoArticleId = selectedArray[0].DOC.METADATAID;
            }).then(() => {
                saveList().then(() => {
                    let signParams = angular.extend({
                        baiJiaHaoArticleId: $state.params.baijiahaoarticleid,
                        accountId: $state.params.baijiahaoaccount,
                    }, baijiaConst.sign);
                    messagePublishService.publish('doEditPageOperation', signParams);
                });
            });
        };

        /**
         * [updateCKSelection description]更新稿费状态
         * @param  {[obj]} list [description]稿件对象
         * @return {[type]}     [description]
         */
        $scope.updateCKSelection = function (list) {
            list.ISNOPAYMENT = list.ISNOPAYMENT === '1' ? '0' : '1';
        };

        /**
     * [theFormError description] 获取表单变化
     * @return {[type]} [description]
     */
        $scope.theFormError = function () {
            // 当表单发生变化时会进入方法
            var errorArray = [];
            for (var error in $scope.bjhNewsForm.$error) {
                errorArray.push(error);
            }
            $scope.status.videoFormError = !$scope.status.videoFormError ? [] : $scope.status.videoFormError;
            if ($scope.status.videoFormError.length !== errorArray.length) {
                // 长度不相等说明表单errorname发生变化
                $scope.status.videoFormError = errorArray;
            }
            return $scope.status.videoFormError; // 返回
        };

        /**
         * [deleteUploaderImg description]删除上传后的图片
         * @param   {[type]}  index  [index description] 删除的位置
         * @return  {[type]}         [return description]
         */
        $scope.deleteUploaderImg = function (index) {
            $scope.list.POSTER.splice(index, 1);
            // if ($scope.list.POSTER[$scope.list.POSTER.length - 1].IMAGENAME) {
            //     // showAddCover();
            // }
        };

        /**
         * [scaleImg description] 封面图裁剪完图片后判断是否显示加号
         * @return  {[type]}         [return description]
         */
        // $scope.scaleImg = function () {
        //     if ($scope.list.POSTER.length < 3 && $scope.list.POSTER[$scope.list.POSTER.length - 1].IMAGENAME) {
        //         // showAddCover();
        //     }
        //     // });
        // };


        /**
         * [revise description]
         * @return  {[type]}  [return description]
         */
        $scope.revise = function () {
            modalDialog.confirmModal('修订', '确认修订?', function () {
                saveList().then(function (data) {
                    var params = {
                        MediaType: $scope.status.mediaType
                    };
                    $scope.loadingPromise = editingCenterService.reviseFinished(params);
                });
            });
        };

        /**
         * [showVersion description] 判断是融合编辑下的获取版本记录还是渠道内的获取版本记录
         * @return  {[type]}  [return description]
         */
        function showVersion() {
            if ($scope.status.isFusionEditor) {
                getFusionVersion();
            } else {
                getVersion();
                getPropagandaReview();
            }
        }

        /**
         * [getVersion description] 获取流程记录
         * @return  {[type]}  [return description]
         */
        function getVersion() {
            newMediaService.getVersion($scope.status.mediaType, $state.params.baijiahaoarticleid).then(function (data) {
                $scope.data.records = data;
            });
        }

        /**
         * [getVersion description] 获取融合编辑流程记录
         * @return {[type]} [description]
         */
        function getFusionVersion() {
            var deffer = $q.defer();
            editingCenterService.getEditVersionTime(
                $scope.data.sourceDocId || $state.params.iwometadataid,
                $scope.page,
                $scope.data.copyVersion
            ).then(function (data) {
                $scope.data.version = data;
                $scope.page = data.page;
                $scope.data.copyVersion = data.copyArray;
                $scope.status.hasVersionTime = true;
                $scope.data.lastVersionid = data.lastVersionid;
                deffer.resolve();
            },
            function () {
                deffer.resolve();
            });
            return deffer.promise;
        }

        /**
         * [getLoadMore description]操作日志加载更多
         * @return {[type]} [description]
         */
        $scope.getLoadMore = function () {
            $scope.page.CURRPAGE++;
            getFusionVersion();
        };

        /**
         * [openPersonalVersionTime description] 打开流程版本详情页
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.openPersonalVersionTime = function (item) {
            newMediaService.openPersonalVersionTime($state.params.iwometadataid, item);
        };

        /**
         * [closeCurrView description] 页面关闭
         * @return  {[type]}  [return description]
         */
        $scope.closeCurrView = function () {
            baijiahaoService.baijiahaoUnlock($scope.bjhNewsForm, $scope.list, saveList, $state.params.baijiahaoarticleid);
        };

        /**
         * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
         * @return {[type]} [description]
         */
        function emitCloseWindow() {
            editingCenterService.allAppCloseWindow($scope, { typeName: 'baijiahao', saveLocal: false });
        }
        $scope.changeMode = function (item) {
            $scope.status.showByNum = item.value;
            // var delateArr;
            // // 还需要插入多少个加号
            // var length = Number(item.value) - $scope.list.POSTER.length;
            // if (length >= 0) {
            //     for (let i = 0; i < length; i++) {
            //         $scope.list.POSTER.push({});
            //     }
            // } else {
            //     delateArr = $scope.list.POSTER.slice(0, length);
            //     $scope.list.POSTER.length = item.value;
            //     console.log(delateArr);
            // }

        };
    }
]);
